import { Field, ObjectType } from 'type-graphql'
import { User } from '../user/User'

export type AuthenticationType = 'basic' | 'google' | 'facebook'

@ObjectType()
export class UserAuth {
  @Field(() => User)
  user: User

  @Field(() => String)
  accessToken: string

  @Field(() => String)
  refreshToken?: string

  @Field(() => String)
  type?: string
}
